import { createSlice } from '@reduxjs/toolkit';
import {
  ProjectState,
} from "../../shared";

type UploadState = {
  projects: ProjectState[];
  progress: { [key: string]: number };
}

export const INITIAL_STATE: UploadState = {
  projects: [],
  progress: {}
};

export const upload = createSlice({
  name: 'upload',
  initialState: INITIAL_STATE,
  reducers: {
    resetUpload: (state) => {
      for (const key in INITIAL_STATE) {
        (state as any)[key] = (INITIAL_STATE as any)[key];
      }
    },
    setUploadState: (state, action) => {
      const _state = action.payload;
      for (const key in INITIAL_STATE) {
        if (key in _state) {
          (state as any)[key] = (_state as any)[key];
        } else {
          (state as any)[key] = (INITIAL_STATE as any)[key];
        }
      }
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    setProgress: (state, action) => {
      const { projectId, progress } = action.payload;
      if (projectId) {
        state.progress[projectId] = progress;
      }
    },
    uploadProject: (state, action) => {
      const newProject: ProjectState = action.payload;
      const newProjects: ProjectState[] = [];
      state.projects.forEach(project => {
        if (project.projectId !== newProject.projectId) {
          newProjects.push(project);
        }
      });
      newProjects.push(newProject);
      state.projects = newProjects;
      if (newProject.projectId) {
        state.progress[newProject.projectId] = 0;
      }
    },
    removeProject: (state, action) => {
      const projectId = action.payload;
      const newProjects: ProjectState[] = [];
      state.projects.forEach(project => {
        if (project.projectId !== projectId) {
          newProjects.push(project);
        }
      })
      state.projects = newProjects;
      if (projectId in state.progress) {
        delete state.progress[projectId];
      }
    },
  },
});

export const {
  resetUpload,
  setUploadState,
  setProjects,
  setProgress,
  uploadProject,
  removeProject
} = upload.actions;

export default upload.reducer;